
import {Reducer} from "redux";
import * as Routines from "../routines";
import { AlarmAnalysisState } from "@Safemate/map/Store/types";

const alarmAnalysis: Reducer<AlarmAnalysisState> = (state: AlarmAnalysisState = {}, action) => {
  switch (action.type) {
    case Routines.alarmAnalysis.SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload.analysis
      };

    default:
      return state;
  }
};

export default alarmAnalysis;
